import { render, staticRenderFns } from "./EditPatientModal.vue?vue&type=template&id=eb4b48f8&scoped=true"
import script from "./EditPatientModal.vue?vue&type=script&lang=js"
export * from "./EditPatientModal.vue?vue&type=script&lang=js"
import style0 from "./EditPatientModal.vue?vue&type=style&index=0&id=eb4b48f8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "eb4b48f8",
  null
  
)

export default component.exports